import { render, staticRenderFns } from "./OrderCount.vue?vue&type=template&id=8645e0b2&scoped=true&"
import script from "./OrderCount.vue?vue&type=script&lang=js&"
export * from "./OrderCount.vue?vue&type=script&lang=js&"
import style0 from "./OrderCount.vue?vue&type=style&index=0&id=8645e0b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_@vue+com_158fd1d6ef9e4cc6d0695d4cab9c983b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8645e0b2",
  null
  
)

export default component.exports